import { Box, Stack } from 'styles';
import { IHistoryItem } from 'types/History';
import HistoryItemActor from './HistoryItemActor.component';
import HistoryItemContent from './HistoryItemContent.component';
import HistoryItemIcon from './HistoryItemIcon.component';

type Props = {
	item: IHistoryItem;
	isLast?: boolean;
};

const HistoryItem = ({ item, isLast }: Props) => {
	return (
		<>
			<Stack gap={'24px'} flexDirection={'row'} alignItems={'stretch'}>
				<HistoryItemIcon item={item} isLast={isLast} />
				<Stack gap="20px">
					<HistoryItemContent item={item} />
					{item.createdBy && <HistoryItemActor item={item} />}
				</Stack>
			</Stack>
			{!isLast && (
				<Box
					height={'40px'}
					display={'flex'}
					justifyContent={'center'}
					width={'24px'}
				>
					<Box width={'1px'} height={'100%'} backgroundColor={'grey4.main'} />
				</Box>
			)}
		</>
	);
};

export default HistoryItem;
